"use client";

import { usePathname } from "next/navigation";
import { isLandingPath } from "@/lib/landing-paths";
import TopNav from "./TopNav";

export default function ConditionalTopNav() {
  const pathname = usePathname();
  
  // Landing pages bring their own nav.
  if (isLandingPath(pathname)) {
    return null;
  }
  
  return <TopNav />;
}
